import React from 'react';

const EventContent = props => {
    const data = props.data;

    const comparator = (a, b) => {
        if( a.result < b.result ) return -1;
        if( a.result > b.result ) return 1;
        return 0;
    }

    const extracted = data
        .filter( f => f.qnaDelta )
        .map( f => { return { result: f.stats?.place ?? 'X', name: f.name, qnaDelta: f.qnaDelta } } )
        .sort( comparator )
        .map( (f, inx) => <li key={inx}>{f.result}: {f.name} {f.qnaDelta }</li> );

    return ( <ul>{extracted}</ul> );
}

export default EventContent;